'use strict';

// Static Methods
require('../date/range');

// Prototype Methods
require('./clamp');
require('./clone');
require('./contains');
require('./days');
require('./every');
require('./hours');
require('./intersect');
require('./isValid');
require('./milliseconds');
require('./minutes');
require('./months');
require('./seconds');
require('./span');
require('./toArray');
require('./toString');
require('./union');
require('./weeks');
require('./years');

module.exports = require('sugar-core');


// WEBPACK FOOTER //
// ./~/sugar-date/range/index.js